import { render } from "./EventWebPage.vue?vue&type=template&id=27e6b928&scoped=true&ts=true"
import script from "./EventWebPage.vue?vue&type=script&lang=ts"
export * from "./EventWebPage.vue?vue&type=script&lang=ts"

import "./EventWebPage.vue?vue&type=style&index=0&id=27e6b928&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e6b928"]])

export default __exports__